<div class="payment-redirect">
  <!-- Success State -->
  <div class="success-message" *ngIf="displayStatus === 'success'">
    <div class="icon-check">
      <i data-feather="check-circle"></i>
    </div>
    <h2>¡Pago Aprobado!</h2>
    <p>Tu pago ha sido procesado exitosamente.</p>
    <p class="small">Esta ventana se cerrará automáticamente.</p>
  </div>

  <!-- Pending State -->
  <div class="success-message pending" *ngIf="displayStatus === 'pending'">
    <div class="icon-check">
      <i data-feather="clock"></i>
    </div>
    <h2>Pago Pendiente</h2>
    <p>Tu pago está siendo procesado.</p>
    <p class="small">Esta ventana se cerrará automáticamente.</p>
  </div>

  <!-- Cancelled State -->
  <div class="success-message cancelled" *ngIf="displayStatus === 'cancelled'">
    <div class="icon-check">
      <i data-feather="x-circle"></i>
    </div>
    <h2>Pago Cancelado</h2>
    <p>Has cancelado el pago.</p>
    <p class="small">Esta ventana se cerrará automáticamente.</p>
  </div>

  <!-- Error State -->
  <div class="success-message error" *ngIf="displayStatus === 'error'">
    <div class="icon-check">
      <i data-feather="alert-circle"></i>
    </div>
    <h2>Error en el Pago</h2>
    <p>Hubo un problema al procesar tu pago.</p>
    <p class="small">Esta ventana se cerrará automáticamente.</p>
  </div>
</div>
